import { actions } from './actions'

const initialState = {
  tiposSvg: {
    data: [],
    loading: false,
    error: '',
  },
  tipoSvg: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function tiposSvgReducer(state = initialState, action) {
  switch (action.type) {
    case actions.TIPOS_SVG_LOAD_REQUESTED:
      return { ...state, tiposSvg: { ...state.tiposSvg, loading: true } }
    case actions.TIPOS_SVG_LOAD_SUCCEEDED:
      return {
        ...state,
        tiposSvg: { ...state.tiposSvg, data: action.payload, loading: false },
      }
    case actions.TIPOS_SVG_LOAD_FAILED:
      return {
        ...state,
        tiposSvg: { ...state.tiposSvg, loading: false, error: action.error },
      }
    case actions.TIPOS_SVG_INSERT_REQUESTED:
      return {
        ...state,
        tipoSvg: { ...state.tipoSvg, loading: true, error: '' },
      }
    case actions.TIPOS_SVG_INSERT_SUCCEEDED:
      return {
        ...state,
        tiposSvg: {
          ...state.tiposSvg,
          data: [...state.tiposSvg.data, action.payload],
          loading: false,
          error: '',
        },
        tipoSvg: {
          ...state.tipoSvg,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.TIPOS_SVG_INSERT_FAILED:
      return {
        ...state,
        tipoSvg: { ...state.tipoSvg, loading: false, error: action.error },
      }
    default:
      return state
  }
}
